module.exports = __webpack_public_path__ + "media/application/images/public_square/logo_main-64dee087b57ff5b73e917239b6b09ef8.png";